import BrandLogo from 'common/BrandLogo';
import HeadingLarge from 'common/HeadingLarge';
import SuccessMessage from 'common/SuccessMessage';
import { styled } from 'styled-components';

import Button from '../common/Button';

const Div = styled.div`
    background:
        linear-gradient(270deg, rgba(245, 241, 237, 0) 19.36%, #f5f1ed 100%),
        url('/bgImage.jpeg') lightgray 50%;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: top left;
    min-height: 100vh;
    .textContainer {
        margin-top: 0px;
        padding: 60px 120px;
    

    .congrats {
        color: ${(props) => props.theme.primaryFontColor};
        font-family: Poppins;
        font-size: 16px;
        font-weight: 700;
    }
    .message {
        color: ${(props) => props.theme.primaryFontColor};
        font-family: Poppins;
        font-size: 16px;
        font-weight: 400;
        margin: 10px 0px;
    }
    .btn {
        width: 20%;
        margin: 20px 0px;
    }
`;
export default function Home() {
    return (
        <>
            <BrandLogo></BrandLogo>
            <Div>
                <div className="textContainer">
                    <SuccessMessage>Account Created!</SuccessMessage>
                    <HeadingLarge>Welcome to Be:Seen Health</HeadingLarge>
                    <div
                        style={{
                            width: '45%',
                        }}
                    >
                        <div className="congrats">Congratulations</div>

                        <div className="message">
                            Your account has been successfully created. We're excited to have you on board. Next time
                            you log in, you'll be able to easily search for, book, and pay for appointments with top
                            health providers in your area.
                        </div>
                        <div className="message">
                            We're here to make your healthcare journey smooth and stress-free.
                        </div>
                    </div>

                    <Button className="btn">Go to Home Page</Button>

                    <p
                        style={{
                            color: '#999999',
                            fontFamily: 'Poppins',
                            fontSize: '14px',
                            fontStyle: 'normal',
                            fontWeight: 500,
                            width: '30%',
                        }}
                    >
                        You can explore our platform and start searching for providers right away. If you have any
                        questions, our support team is here to help.
                    </p>
                </div>
            </Div>
        </>
    );
}
